// Module
var code = "<template>\n    <a route-href.bind=\"route\" class=\"waves-effect ${router.currentInstruction.config.name == route ? 'mm-active' : ''}\">\n        <i class=\"bx ${icon}\"></i>\n        <span>${title}</span>\n    </a>\n</template>";
// Exports
export default code;